/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TextAddIcon = ({ width = 24, height = 24, hidden = false, title = 'Text Add' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m15,10.50003c-2.48529,0-4.5,2.01471-4.5,4.5s2.01471,4.5,4.5,4.5,4.5-2.01471,4.5-4.5-2.01471-4.5-4.5-4.5Zm2.5,5.125h-1.875v1.875c0,.34473-.28027.625-.625.625s-.625-.28027-.625-.625v-1.875h-1.875c-.34473,0-.625-.28027-.625-.625s.28027-.625.625-.625h1.875v-1.875c0-.34473.28027-.625.625-.625s.625.28027.625.625v1.875h1.875c.34473,0,.625.28027.625.625s-.28027.625-.625.625Z"
      fill="currentColor"
    />
    <path
      d="m12.58984,1.99807H3.41016c-1.24072,0-2.25,1.00977-2.25,2.25v1.11035c0,.41406.33594.75.75.75s.75-.33594.75-.75v-1.11035c0-.41309.33643-.75.75-.75h3.83984v13h-1.5c-.41406,0-.75.33594-.75.75s.33594.75.75.75h3.13086c.41406,0,.75-.33594.75-.75s-.33594-.75-.75-.75h-.13086V3.49807h3.83984c.41357,0,.75.33691.75.75v1.11035c0,.41406.33594.75.75.75s.75-.33594.75-.75v-1.11035c0-1.24023-1.00928-2.25-2.25-2.25Z"
      fill="currentColor"
    />
  </svg>`;
};
